var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHdiFigma(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 32,
    viewBox: "0 0 92 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8438 10.6667H10.8971V21.3334H22.8438V10.6667Z",
    fill: "#DD2D27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.230438 0H11.132V32H0.230438V0ZM22.5647 0H33.4663V32H22.5647V0ZM80.6356 0H91.5371V32H80.6385L80.6356 0ZM42.6001 0.287572H57.3853C66.1102 0.287572 73.251 7.43307 73.251 16.1128C73.251 24.7983 66.1102 31.9423 57.3853 31.9423H42.6001V0.287572ZM52.6069 7.94617H53.866C58.831 7.94617 62.8916 11.7204 62.8916 16.3295C62.8916 20.9416 58.831 24.7129 53.866 24.7129H52.6069V7.94617Z",
    fill: "#00A657"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHdiFigma);
export default __webpack_public_path__ + "static/media/logoHdiFigma.90db35400a2254d405ab9d3cc8552ec9.svg";
export { ForwardRef as ReactComponent };